import { TableField } from "../../table-field";

const nmAutor: TableField = {
    key: "NmAutor",
    label: "Autor(a)",
    tdClass: ["align-middle", "quebrarPorPalavraHard"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
};
const tipoAutor: TableField = {
    key: "TipoAutor",
    label: "Tipo",
    tdClass: ["align-middle", "quebrarPorPalavraHard"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
};
const inicioMandato: TableField = {
    key: "NrAnoInicioMandato",
    label: "Início do Mandato",
    tdClass: ["align-middle", "naoQuebrar"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
};
const fimMandato: TableField = {
    key: "NrAnoFimMandato",
    label: "Fim do Mandato",
    tdClass: ["align-middle", "naoQuebrar"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
};
const actions = {
    key: "actions",
    label: "Ações",
    tdClass: ["align-middle", "col-actions"],
    thClass: "text-center",
    sortable: false,
};

export const fieldsAutores: TableField[] = [
    nmAutor,
    tipoAutor,
    inicioMandato,
    fimMandato,
    actions,
];
